const config = {
  name: 'Product Overview Tile',
  defaultStyles: {
    padding: '16px',
    width: '333px',
    backgroundColor: '#ffffff',
  },
  inputs: [
    {
      name: 'productPermalink',
      type: 'string',
      required: true,
      defaultValue: 'womens-organic-cotton-box-cut-pocket-tee-white',
    },
    {
      name: 'showPrice',
      type: 'boolean',
      defaultValue: true,
    },
    {
      name: 'showColorName',
      type: 'boolean',
      defaultValue: true,
    },
    {
      name: 'showBadge',
      type: 'boolean',
      defaultValue: false,
    },
    {
      name: 'overlay',
      type: 'boolean',
      defaultValue: false,
    },
    {
      name: 'customLeadImage',
      type: 'string',
      helperText:
        'Change the default primary image of the product to a custom asset. Example: i/841d87fc_904c',
      defaultValue: null,
    },
  ],
}

export default config
